import {
  parseAsString,
  useQueryState,
  type HistoryOptions,
} from '@vrplatform/query-params';

export function useListingFeeDrawer() {
  const [listingId, setListingId] = useQueryState('listing-fee', parseAsString);

  return {
    opened: !!listingId,
    open: (id: string, updateType?: HistoryOptions) =>
      setListingId(id, { history: updateType || 'push' }),
    close: () => setListingId(null),
    listingId,
  };
}
